import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { userInfo } from '../../redux/slice';
import { get } from '../../util/request';

// Loads a configurable "Tax Questionnaire" content row by type (e.g. State Tax Warning, Wise Reminder, PayNow URL).
// Returns the ContentVO ({ contentEN, contentTC, contentSC, contentJA, ... }) or null when the row is missing or the call fails,
// so callers can fall back to their defaults. Use getLocalizedContent() for language-specific text.
export default function useTaxContent(type) {
    const user = useSelector(userInfo);
    const [content, setContent] = useState(null);

    useEffect(() => {
        let active = true;
        get('/taxQuestionnaire/content', { accessToken: user.accessToken, userId: user.userId, type })
            .then((data) => active && setContent(data || null))
            .catch(() => active && setContent(null));
        return () => { active = false; };
    }, [type]);

    return content;
}
